(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/envelope/assets/javascripts/index.js') >= 0) return;  svs.modules.push('/components/tur/envelope/assets/javascripts/index.js');
"use strict";


const {
  useEffect,
  useRef,
  useState
} = React;
const {
  ContentImages,
  ConcaveShadow
} = svs.tur.envelope.components;

const Envelope = _ref => {
  let {
    branding,
    bodyColor = 'white',
    children,
    className,
    content,
    image,
    repeatImage,
    images,
    style = {}
  } = _ref;
  const bodyRef = useRef(null);
  const [showConcave, setShowConcave] = useState(false);
  let repeatedImages;
  if (repeatImage > 1 && image) {
    repeatedImages = Array.from({
      length: repeatImage
    }, () => image);
  }
  const contentImages = repeatedImages || images || image && [image];
  useEffect(() => {
    if (bodyRef.current) {
      bodyRef.current.style.setProperty('--bgColor', bodyColor);
      setShowConcave(true);
    }
  }, [bodyColor]);
  return React.createElement("div", {
    className: "envelope elevation-100".concat(branding === 'triss' ? ' branding-triss' : '', " ").concat(className ? className : ''),
    style: style
  }, React.createElement("div", {
    className: "envelope-lid"
  }), contentImages && contentImages.length && React.createElement(ContentImages, {
    images: contentImages
  }), content, showConcave && React.createElement(ConcaveShadow, {
    fillColor: bodyColor,
    parentRef: bodyRef
  }), React.createElement("div", {
    className: "envelope-body",
    ref: bodyRef
  }, children));
};
setGlobal('svs.tur.Envelope', Envelope);

 })(window);